(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scent-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scent-quiz]').forEach((root) => {
    if (root.dataset.quizReady === 'true') return;
    root.dataset.quizReady = 'true';

    const intro = root.querySelector('[data-quiz-intro]');
    const form = root.querySelector('[data-quiz-form]');
    const results = root.querySelector('[data-quiz-results]');
    const questions = Array.from(root.querySelectorAll('[data-quiz-question]'));
    const progressText = root.querySelector('[data-quiz-progress-text]');
    const progressBar = root.querySelector('[data-quiz-progress-bar]');
    const answers = [];

    const splitValues = (value) => (value || '').split(',').map((item) => item.trim()).filter(Boolean);

    const showQuestion = (index) => {
      questions.forEach((question, questionIndex) => {
        question.hidden = questionIndex !== index;
      });
      progressText.textContent = `${index + 1} OF ${questions.length}`;
      progressBar.style.width = `${((index + 1) / questions.length) * 100}%`;
    };

    const showResults = () => {
      form.hidden = true;
      results.hidden = false;
      const cards = Array.from(root.querySelectorAll('[data-quiz-result-card]'));
      const scored = cards.map((card, index) => {
        const profiles = splitValues(card.dataset.profiles);
        const occasions = splitValues(card.dataset.occasion);
        const audiences = splitValues(card.dataset.audience);
        const family = card.dataset.family || 'other';
        const scentIntensity = Number(card.dataset.intensity || 2);
        let score = 0;

        answers.forEach((answer) => {
          answer.profiles.forEach((profile) => {
            if (profiles.includes(profile)) score += 3;
          });
          answer.avoid.forEach((profile) => {
            if (profiles.includes(profile)) score -= 4;
          });
          if (answer.occasion === 'all') {
            score += occasions.includes('all') ? 3 : 1;
          } else if (answer.occasion) {
            if (occasions.includes(answer.occasion)) score += 4;
            if (occasions.includes('all')) score += 2;
          }
          if (answer.audience === 'feminine') {
            if (audiences.includes('feminine')) score += 10;
            else if (audiences.includes('unisex') && !audiences.includes('masculine')) score += 3;
            else score -= 10;
          } else if (answer.audience === 'masculine') {
            if (audiences.includes('masculine')) score += 10;
            else if (audiences.includes('unisex') && !audiences.includes('feminine')) score += 3;
            else score -= 10;
          } else if (answer.audience === 'unisex' && audiences.includes('unisex')) {
            score += 8;
          }
          if (answer.intensity > 0) {
            score += Math.max(0, 4 - Math.abs(answer.intensity - scentIntensity) * 2);
          }
        });

        return { card, score, index, family };
      }).sort((a, b) => b.score - a.score || a.index - b.index);

      const selected = [];
      const usedFamilies = new Set();
      scored.forEach((item) => {
        if (selected.length >= 3) return;
        if (selected.length === 0 || !usedFamilies.has(item.family)) {
          selected.push(item);
          usedFamilies.add(item.family);
        }
      });
      scored.forEach((item) => {
        if (selected.length >= 3 || selected.includes(item)) return;
        selected.push(item);
      });

      cards.forEach((card) => {
        card.hidden = true;
        card.classList.remove('is-best-match');
      });

      selected.forEach((item, index) => {
        item.card.hidden = false;
        item.card.style.order = index;
        item.card.classList.toggle('is-best-match', index === 0);
        const rank = item.card.querySelector('[data-quiz-rank]');
        rank.textContent = index === 0 ? 'YOUR BEST MATCH' : 'ALSO VERY YOU';
      });

      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    root.querySelector('[data-quiz-start]').addEventListener('click', () => {
      intro.hidden = true;
      form.hidden = false;
      showQuestion(0);
    });

    root.querySelectorAll('[data-quiz-answer]').forEach((button) => {
      button.addEventListener('click', () => {
        const question = button.closest('[data-quiz-question]');
        const step = Number(question.dataset.step);
        question.querySelectorAll('[data-quiz-answer]').forEach((answerButton) => {
          answerButton.setAttribute('aria-pressed', String(answerButton === button));
        });
        answers[step] = {
          profiles: splitValues(button.dataset.profiles),
          avoid: splitValues(button.dataset.avoid),
          occasion: button.dataset.occasion || '',
          audience: button.dataset.audience || '',
          intensity: Number(button.dataset.intensity || 0)
        };
        window.setTimeout(() => {
          if (step + 1 < questions.length) showQuestion(step + 1);
          else showResults();
        }, 180);
      });
    });

    root.querySelectorAll('[data-quiz-back]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.closest('[data-quiz-question]').dataset.step);
        showQuestion(Math.max(0, step - 1));
      });
    });

    root.querySelector('[data-quiz-restart]').addEventListener('click', () => {
      answers.length = 0;
      root.querySelectorAll('[data-quiz-answer]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      results.hidden = true;
      intro.hidden = false;
      intro.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
